module.exports = __webpack_public_path__ + "img/project_knowledge_based_planning.2b62d39f.png";